import { useEffect, useState } from 'react';
import purifier from 'utils/purifier';

const useRawMarkup = (template: string) => {
  const [purifiedHtml, setPurifiedHtml] = useState('');

  useEffect(() => {
    setPurifiedHtml(purifier({ source: template }));
  }, [template]);

  return {
    __html: purifiedHtml,
  };
};

export default useRawMarkup;
